import suggestionFormatSchema from "../../../docs/AI_SUGGESTION_FORMAT.schema.json" with {
  type: "json",
};

export const SUGGESTION_FORMAT_SCHEMA = suggestionFormatSchema as Record<string, unknown>;
